"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleOptions = exports.default = exports.cursorOptions = void 0;

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _excluded = ["classes", "cursorStyle", "sliderStyle"];

var _cursorBy, _styledBy, _styledBy2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleOptions = {
  default: 'default',
  inverted: 'inverted'
};
exports.styleOptions = styleOptions;
var cursorOptions = {
  default: 'default',
  pointer: 'pointer'
};
exports.cursorOptions = cursorOptions;

var styledBy = function styledBy(mapping) {
  return function (props) {
    return mapping[props.sliderStyle];
  };
};

var cursorBy = function cursorBy(mapping) {
  return function (props) {
    return mapping[props.cursorStyle];
  };
};

var CustomSlider = (0, _styledComponents.withTheme)((0, _styles.withStyles)({
  root: {
    height: 18,
    marginTop: 12,
    cursor: cursorBy((_cursorBy = {}, _defineProperty(_cursorBy, cursorOptions.default, 'default'), _defineProperty(_cursorBy, cursorOptions.pointer, 'pointer'), _cursorBy)),
    '&.max .MuiSlider-valueLabel:before': {
      width: 56,
      left: -12
    }
  },
  thumb: {
    display: function display(props) {
      return props.disabled ? 'none' : 'block';
    },
    marginTop: -5,
    height: 15,
    width: 15,
    '&:hover': {
      boxShadow: cursorBy(_defineProperty({}, cursorOptions.default, 'unset'))
    }
  },
  valueLabel: {
    left: 'calc(-50% - 4px)',
    fontSize: 9,
    top: -19,
    marginLeft: 3,
    '& *': {
      background: 'transparent',
      color: 'white'
    },
    '&:before': {
      width: 32,
      height: 15,
      background: 'rgb(255, 151, 79)',
      content: '\'\'',
      position: 'absolute',
      marginTop: 8,
      borderRadius: 4
    },
    '&:after': {
      width: 10,
      height: 10,
      position: 'absolute',
      content: '\'\'',
      background: 'rgb(255, 151, 79)',
      bottom: 5,
      transform: 'rotate(45deg)',
      marginLeft: 'calc(50% - 5px)',
      zIndex: -1
    }
  },
  track: {
    height: 5,
    color: styledBy((_styledBy = {}, _defineProperty(_styledBy, styleOptions.default, function (props) {
      return props.theme.colors.main;
    }), _defineProperty(_styledBy, styleOptions.inverted, 'rgb(236, 236,236)'), _styledBy)),
    opacity: 1
  },
  rail: {
    height: 5,
    backgroundColor: styledBy((_styledBy2 = {}, _defineProperty(_styledBy2, styleOptions.default, 'rgb(236, 236,236)'), _defineProperty(_styledBy2, styleOptions.inverted, function (props) {
      return props.theme.colors.main;
    }), _styledBy2)),
    opacity: 1
  },
  markLabel: {
    fontSize: 9,
    marginTop: 8,
    color: '#ccc'
  },
  mark: {
    marginTop: 8,
    height: 8,
    color: '#ccc',
    width: 1
  },
  markActive: {
    backgroundColor: '#ccc'
  }
})(function (_ref) {
  var classes = _ref.classes,
      cursorStyle = _ref.cursorStyle,
      sliderStyle = _ref.sliderStyle,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _react.default.createElement(_Slider.default, _extends({
    className: classes.root,
    classes: classes
  }, rest));
}));

var MySlider = function MySlider(_ref2) {
  var disabled = _ref2.disabled,
      _ref2$from = _ref2.from,
      from = _ref2$from === void 0 ? 0 : _ref2$from,
      _ref2$grid = _ref2.grid,
      grid = _ref2$grid === void 0 ? true : _ref2$grid,
      _ref2$marksDelta = _ref2.marksDelta,
      marksDelta = _ref2$marksDelta === void 0 ? 10 : _ref2$marksDelta,
      max = _ref2.max,
      min = _ref2.min,
      _ref2$onChange = _ref2.onChange,
      _onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
      postfix = _ref2.postfix,
      _ref2$sliderStyle = _ref2.sliderStyle,
      sliderStyle = _ref2$sliderStyle === void 0 ? styleOptions.default : _ref2$sliderStyle,
      _ref2$step = _ref2.step,
      step = _ref2$step === void 0 ? 1 : _ref2$step,
      values = _ref2.values,
      _ref2$cursorStyle = _ref2.cursorStyle,
      cursorStyle = _ref2$cursorStyle === void 0 ? cursorOptions.pointer : _ref2$cursorStyle,
      customMarks = _ref2.customMarks,
      scale = _ref2.scale;

  var getMarks = function getMarks(min, max, initDelta) {
    var minMarks = 5,
        maxMarks = 15;

    var getNumOfMarks = function getNumOfMarks(delta) {
      return (max - min) / delta;
    };

    var getDelta = function getDelta(delta) {
      var nM = getNumOfMarks(delta);
      if (max - min < 15) return 1;

      if (nM > maxMarks) {
        delta = delta * 10;
        return getDelta(delta);
      } else if (nM < minMarks) {
        delta = delta / 2;
        return getDelta(delta);
      } else {
        return delta;
      }
    };

    var delta = getDelta(initDelta);
    var rest = min % marksDelta;
    var result = [];

    for (var i = min; i <= max; i = i + delta) {
      var value = i === min ? min : i - rest;
      result.push({
        label: value,
        value: value
      });
    }

    return result;
  };

  var valuetext = function valuetext(value) {
    return postfix ? "".concat(value, " ").concat(postfix) : value;
  };

  var marks = (0, _react.useMemo)(function () {
    return customMarks || (values ? values.map(function (value, index) {
      return {
        value: index,
        label: value
      };
    }) : min !== undefined && max !== undefined && grid ? getMarks(min, max, marksDelta) : undefined);
  }, [values, min, max, grid, marksDelta]);
  return _react.default.createElement(CustomSlider, {
    "aria-labelledby": "discrete-slider",
    className: (0, _clsx.default)({
      max: max > 99999
    }),
    disabled: disabled,
    cursorStyle: cursorStyle,
    sliderStyle: sliderStyle,
    marks: marks,
    max: values ? values.length - 1 : Number(max),
    min: values ? 0 : Number(min),
    onChange: function onChange(e, value) {
      return _onChange(value);
    },
    step: values ? 1 : Number(step),
    value: Array.isArray(from) ? from : isNaN(Number(from)) ? Number(min) : Number(from),
    valueLabelDisplay: values ? "off" : "on",
    valueLabelFormat: valuetext,
    scale: scale
  });
};

var _default = MySlider;
exports.default = _default;